exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DebugContainer.theme-code{margin:1em;padding:1em;background-color:#282a36;color:#f8f8f2;border-radius:.5em;white-space:pre-wrap}", ""]);
